import axios from "axios";
import { errorHandler } from "@/Services/errorHandler";
import queryStringify from "qs-stringify";

export default {
    state: {
        storeCurrencies : [],
        baseCurrency : {Symbol : "K" , rate : 1 , Name : "Kwacha" , id : 1}
    },
    getters: {
        getBaseCurrency:(state) =>state.baseCurrency,
        getAllCurrencies : (state) => state.storeCurrencies,
        getCurrencyBySymbol : (state) => (symbol) => state.storeCurrencies.find(c=>c.Symbol=== symbol),
        getCurrencyById : (state) => (id) => state.storeCurrencies.find(c=>c.id=== id)
    },
    mutations: {
        setStoreCurrencies : (state,data) => state.storeCurrencies = data,
        setBaseCurrency : (state,data) => state.baseCurrency = data,
    },
    actions: {
        getAllCurrencies:(context) => {
            let store = context.getters.getStore;
            if (!store || store.StoreName === 'All') return ;
            let storeDB = store.StoreDB;
            return axios.get(backOfficeTomcatApi+`currency/${storeDB}/getAll`)
                .then(({data})=>context.commit(`setStoreCurrencies`,data))
                .catch(err=>errorHandler.tomcatError(err));
        },
        getBaseCurrency : async (context) =>{
            let store = context.getters.getStore;
            if (!store || store.StoreName === 'All') return ;
            let storeDB = store.StoreDB;
            return axios.get(franchiseTomcatApi+`currency/${storeDB}/getBaseCurrency`)
                .then(({data})=>context.commit(`setBaseCurrency`,data))
                .catch(err=>errorHandler.tomcatError(err));
        },
    },
};
